import { produce } from 'immer';
import { PieChartSpec, PieChartVisualOverride } from '@/core';
import { OptionsEditorColumn, OptionsEditorGrid } from '@/plugin-editor-components';
import { OverrideColorPicker, OverridesEditor, OverridesEditorProps } from '@/plugin-system';
import { OverrideOptions } from '@/plugin-system/components/editing/OverridesEditor/types';
import { PieChartOptionsEditorProps } from './pie-chart-model';

const options: OverrideOptions<PieChartVisualOverride> = {
  color: {
    title: 'Color',
    property: 'color',
    Component: OverrideColorPicker,
  },
};

export function PieChartOptionsEditorAdvancedSettings(props: PieChartOptionsEditorProps) {
  const { value, onChange } = props;

  const handleOverridesChange: OverridesEditorProps<PieChartVisualOverride>['onChange'] = (overrides) => {
    onChange(
      produce(value, (draft: PieChartSpec) => {
        draft.overrides = overrides;
      })
    );
  };

  return (
    <OptionsEditorGrid>
      <OptionsEditorColumn>
        <OverridesEditor
          overrideOptions={options}
          overrides={props.value.overrides ?? []}
          onChange={handleOverridesChange}
        />
      </OptionsEditorColumn>
    </OptionsEditorGrid>
  );
}
